export default "__VITE_ASSET__KE5fi42r__"